<template>
  <div v-if="meeting" class="members-layout-container">
    <div class="members-layout-top">
      <div class="members-top-container">
        <div class="members-top-logo">
          <img src="../assets/images/p-logo.svg" @click="goToMeeting" />
        </div>

        <div class="members-top-back">
          <v-btn class="white--text" icon @click="goToMeeting">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="members-top-left">
          <h3 class="white--text">
            {{ meeting.organizationName }} - {{ meeting.name }}
          </h3>
        </div>

        <div class="members-top-right">
          <v-menu offset-y right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" text v-bind="attrs" v-on="on">
                <div class="icon-button-container">
                  <div class="icon-button-text">
                    Hantera medlemmar
                  </div>
                  <div class="icon-button-icon">
                    <v-icon right style="color: rgba(255,255,255,1);">
                      mdi-menu-down
                    </v-icon>
                  </div>
                </div>
              </v-btn>
            </template>

            <v-list>
              <upload-members :meeting="meeting"></upload-members>
            </v-list>
          </v-menu>
        </div>

        <div class="members-top-usermenu">
          <user-menu></user-menu>
        </div>
      </div>
    </div>
    <div class="members-layout-actions-text">
      <h2 class="white--text">Medlemmar</h2>
    </div>
    <div class="members-layout-actions-buttons">
      <v-row>
        <v-btn color="white" class="color-a" text>Skicka föranmälan</v-btn>
        <v-btn color="white" class="color-a" text>Skicka inbjudan</v-btn>
      </v-row>
    </div>
    <div class="members-layout-content">
      <!--      <v-card-->
      <!--        class="overflow-y-scroll overflow-x-hidden background&#45;&#45;color-c"-->
      <!--        style="display: flex; flex-flow: column; width: 100%; height: 100%;"-->
      <!--      >-->
      <!--        <div class="rounded-b-0" style="background: white;">-->
      <!--          <div class="mt-row" style="font-weight: bold;">-->
      <!--            <div class="mt-check"><v-checkbox></v-checkbox></div>-->
      <!--            <div class="mt-ballots">Röstsedel</div>-->
      <!--            <div class="mt-ssn">Personnummer</div>-->
      <!--            <div class="mt-name">Namn</div>-->
      <!--            <div class="mt-manual-name">Namn (manuellt)</div>-->
      <!--            <div class="mt-phone">Telefonnummer</div>-->
      <!--            <div class="mt-email">Email</div>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div-->
      <!--          class="overflow-y-scroll overflow-x-hidden rounded-t-0"-->
      <!--          style="background: white; height: 100%;"-->
      <!--        >-->
      <!--          <div-->
      <!--            class="mt-row"-->
      <!--            style="font-size: small;"-->
      <!--            v-for="item in sortedMembers"-->
      <!--            :key="item.id"-->
      <!--            :name="item.id"-->
      <!--          >-->
      <!--            <div class="mt-check"><v-checkbox dense></v-checkbox></div>-->
      <!--            <div class="mt-ballots">-->
      <!--              <input-->
      <!--                id="ballots"-->
      <!--                type="text"-->
      <!--                size="1"-->
      <!--                style="width: 100px"-->
      <!--                :value="item.data.ballots.join(', ')"-->
      <!--                @blur="updateValue"-->
      <!--              />-->
      <!--            </div>-->
      <!--            <div class="mt-ssn">-->
      <!--              <input-->
      <!--                type="text"-->
      <!--                size="1"-->
      <!--                style="width: 150px"-->
      <!--                :value="item.data.ssn"-->
      <!--                @blur="updateValue"-->
      <!--              />-->
      <!--            </div>-->
      <!--            <div class="mt-name">-->
      <!--              <input type="text" :value="item.data.name" @blur="updateValue" />-->
      <!--            </div>-->
      <!--            <div class="mt-manual-name">-->
      <!--              <input-->
      <!--                type="text"-->
      <!--                :value="item.data.manualName"-->
      <!--                @blur="updateValue"-->
      <!--              />-->
      <!--            </div>-->
      <!--            <div class="mt-phone">-->
      <!--              <input type="text" :value="item.data.phone" @blur="updateValue" />-->
      <!--            </div>-->
      <!--            <div class="mt-email">-->
      <!--              <input type="text" :value="item.data.email" @blur="updateValue" />-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </v-card>-->
      <vue-editable-grid
        class="invites-table"
        ref="grid"
        id="mygrid"
        :column-defs="columnDefs"
        :row-data="members"
        row-data-key="id"
        @cell-updated="cellUpdated"
        @link-clicked="activeChanged"
        :enableFilters="false"
      >
      </vue-editable-grid>
    </div>
    <div class="members-layout-bottom"></div>
  </div>
</template>

<script>
import UserMenu from "@/components/UserMenu";
import UploadMembers from "@/components/members/UploadMembers";
import MembersData from "@/assets/lib/members-data";

const collator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base"
});

const membersData = MembersData();

function stopSubscription(self) {
  if (self.subscription) {
    self.subscription.sub();
    self.subscription = null;
  }
}

function startSubscription(self) {
  if (!(self.subscription && self.subscription.meetingId === self.meetingId)) {
    console.log("startSubscription");
    stopSubscription(self);

    if (self.meetingId) {
      self.subscription = {
        meetingId: self.meetingId,
        sub: membersData.meetingMembers(self.meetingId, newData => {
          self.members = self.flattenData(newData);
        })
      };
    }
  }
}

function sortColumn(column) {
  return function sort(a, b) {
    const nameA = a.data[column] ? a.data[column].toString().toUpperCase() : ""; // ignore upper and lowercase
    const nameB = b.data[column] ? b.data[column].toString().toUpperCase() : ""; // ignore upper and lowercase

    return collator.compare(nameA, nameB);
  };
}

function columnDefinitions(weigthed) {
  let columns = [
    {
      field: "active",
      headerName: "Aktiv",
      type: "link",
      sortable: true,
      filter: true,
      editable: false
    },
    {
      field: "ballot",
      headerName: "Röstsedel",
      sortable: true,
      filter: true,
      editable: true
    },
    {
      field: "ssn",
      headerName: "Personnummer",
      sortable: true,
      filter: true,
      editable: false
    },
    {
      field: "name",
      headerName: "Namn",
      sortable: true,
      filter: true,
      editable: false
    }
  ];
  if (weigthed) {
    let sharesColumn = {
      field: "shares",
      headerName: "Andelar",
      type: "numeric",
      sortable: true,
      filter: true,
      editable: true
    };
    columns.splice(2, 0, sharesColumn);
  }
  return columns;
}

export default {
  components: {
    UserMenu,
    UploadMembers
  },
  data() {
    return {
      subscription: null,
      members: []
    };
  },
  computed: {
    meetingId() {
      return this.$route.params.meetingId;
    },
    meeting() {
      return this.$store.getters["meetings/getMeeting"](this.meetingId);
    },
    sortedMembers() {
      const newVersion = [...this.members];

      newVersion.sort(sortColumn("ballots"));

      return newVersion;
    },
    columnDefs() {
      return columnDefinitions(this.isWeighted);
    },
    isWeighted() {
      let weightModel = this.meeting.voteWeightModel;
      console.log("Vote weight model: " + weightModel);
      return weightModel === "weighted" || weightModel === "samfallighet";
    }
  },
  watch: {
    meetingId(newMeetingId) {
      console.log(newMeetingId);
    }
  },
  methods: {
    goToMeeting() {
      console.log("goToMeeting");
      this.$router.push({
        name: "meeting",
        params: { meetingId: this.meetingId }
      });
    },
    cellUpdated(data) {
      let fieldUpdate = {};
      fieldUpdate[data.column.field] = data.value;
      membersData.updateMember(this.meetingId, data.row.id, fieldUpdate);
    },
    activeChanged(data) {
      let clickedInvite = this.members.find(
        invite => invite.id === data.rowData.id
      );
      clickedInvite.active = !clickedInvite.active;
      membersData.updateMember(this.meetingId, clickedInvite.id, {
        active: clickedInvite.active
      });
    },
    flattenData(members) {
      let result = members.map(member => {
        return {
          id: member.id,
          active: member.data.active ?? false,
          ballot: member.data.ballot ?? "",
          shares: member.data.shares ?? 1,
          ssn: member.data.ssn,
          name: member.data.name ?? "Okänd"
        };
      });
      return result;
    }
  },
  mounted() {
    console.log("mounted");
    startSubscription(this);
  },
  beforeRouteEnter(to, from, next) {
    next(self => {
      console.log("routeEnter");
      startSubscription(self);
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log("routeLeave");
    stopSubscription(this);
    next();
  }
};
</script>

<style>
.members-layout-container {
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-rows: min-content min-content 1fr 0;
  gap: 12px 12px;
  grid-template-areas:
    "members-layout-top members-layout-top"
    "members-layout-actions-text members-layout-actions-buttons"
    "members-layout-content members-layout-content"
    "members-layout-bottom members-layout-bottom";
}

.members-layout-top {
  padding: 8px 16px;
  background: #002435;
  -webkit-box-shadow: 0 10px 5px 0 rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 10px 5px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 10px 5px 0 rgba(0, 0, 0, 0.25);
  grid-area: members-layout-top;
}

.members-layout-actions-text {
  padding-left: 16px;
  grid-area: members-layout-actions-text;
}

.members-layout-actions-buttons {
  padding-right: 28px;
  grid-area: members-layout-actions-buttons;
}

.members-layout-content {
  margin-left: 16px;
  margin-right: 16px;
  height: 100%;
  overflow-y: hidden;
  grid-area: members-layout-content;
}

.members-layout-bottom {
  grid-area: members-layout-bottom;
}

.members-top-container {
  display: grid;
  grid-template-columns: 36px auto 1fr auto auto auto;
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas: "members-top-logo members-top-back members-top-left members-top-middle members-top-right members-top-usermenu";
}

.members-top-logo {
  padding-top: 7px;
  grid-area: members-top-logo;
  margin-right: 12px;
  align-self: end;
}

.members-top-back {
  grid-area: members-top-back;
}

.members-top-left {
  margin-left: 12px;
  align-self: center;
  grid-area: members-top-left;
}

.members-top-middle {
  grid-area: members-top-middle;
}

.members-top-right {
  grid-area: members-top-right;
}

.members-top-usermenu {
  grid-area: members-top-usermenu;
}

.mt-row {
  height: 40px;
  display: grid;
  grid-template-columns: 66px 100px 150px 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "mt-check mt-ballots mt-ssn mt-name mt-manual-name mt-phone mt-email";
}

.mt-check {
  grid-area: mt-check;
  align-self: center;
  justify-self: center;
}
.mt-ballots {
  grid-area: mt-ballots;
  align-self: center;
}
.mt-ssn {
  grid-area: mt-ssn;
  align-self: center;
}
.mt-name {
  grid-area: mt-name;
  align-self: center;
}
.mt-manual-name {
  grid-area: mt-manual-name;
  align-self: center;
}
.mt-phone {
  grid-area: mt-phone;
  align-self: center;
}
.mt-email {
  grid-area: mt-email;
  align-self: center;
}

input[type="text"]:focus {
  outline-width: 0px;
  border: none;
  /*border-bottom: 2px solid red;*/
}

.invites-table {
  height: 100%;
  background-color: white;
}
</style>
